<template>
  <v-list-item @click="onClick" :disabled="loading">
    <v-list-item-avatar size="32">
      <v-img v-if="item.code" contain :src="src" :lazy-src="item.logo404Path" @error="onError" />
      <v-icon v-else>mdi-plus</v-icon>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>
        {{ item ? item.name : '플랫폼 추가 요청' }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: ['item', 'loading'],
  data() {
    return {
      logoStatus: true,
      logoRectangleStatus: true,
    }
  },
  computed: {
    src() {
      return this.logoStatus && this.item.logo
        ? this.item.logo
        : this.logoRectangleStatus && this.item.logoRectangle
        ? this.item.logoRectangle
        : this.item.logo404Path
    },
  },
  methods: {
    onClick() {
      if (this.loading) return
      this.$emit('click', this.item)
    },
    onError() {
      if (this.logoStatus) {
        this.logoStatus = false
      } else if (this.logoRectangleStatus) {
        this.logoRectangleStatus = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v-list-item {
  border: 2px solid $gray-20;
  height: 68px;
  border-radius: 8px;

  .v-avatar {
    margin-right: 10px;
  }

  .v-list-item__title {
    font-size: 18px;
    font-weight: bold;
    color: $gray-70;
  }

  &:not(:last-of-type) {
    margin-bottom: 10px;
  }

  &--active {
    border: 2px solid $gray-100;
    transition: all 0.5s ease-out;
  }
}
</style>
